import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Header, Modal, Table } from "@pentabd/ui";

import { ProfileInfoCard, SearchBox } from "@components";

import { EmployeeType } from "@type/HRM/employees";

import { useEmployeeList } from "@hooks/procurements/committee/useEmployeeList";

interface AddPromotionEmployeeModalType {
  isModalOpen: boolean;
  onSaveAction: (arg: (string | number)[], employees: any) => void;
  closeModal: () => void;
}

const AddCommitteeMemberModal = ({
  isModalOpen,
  closeModal,
  onSaveAction,
}: AddPromotionEmployeeModalType) => {
  const { t } = useTranslation();

  const [selectedID, setSelectedID] = useState<(string | number)[]>([]);

  const { employees, pagination, handleQuery } = useEmployeeList();
  const { page, size, total } = pagination || {};

  const { control } = useForm();

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
    >
      <Header
        size="sm"
        headerText={{
          header: t("COMMITTEE.FORM.MODAL.LABEL"),
          // subHeader: t("INITIATE_PROMOTION.FORM.MODAL.SUBTITLE"),
        }}
        className="px-9"
      />
      <div className="p-10">
        <Table
          columns={[
            {
              id: 1,
              key: "nameBn",
              name: t("PROMOTION_CANDIDATES.TABLE.COLUMN.NAME"),
              render: (__: string, row: EmployeeType) => (
                <ProfileInfoCard employee={row as any} />
              ),
            },
          ]}
          rows={employees}
          check={{
            onCheck: (id: (string | number)[]) => {
              setSelectedID(id);
            },
          }}
          pagination={{
            totalPage: Math.ceil(total / size),
            onClick: (currentPage) => handleQuery("page", currentPage),
            activePage: page,
          }}
          headerExtension={{
            leftComponents: [
              <SearchBox
                key="search"
                control={control}
                handleQuery={handleQuery}
              />,
            ],
          }}
        />
      </div>
      <div className="p-9 d-flex justify-content-end align-items-center gap-6">
        <Button size="sm" fill="outline" type="light" onClick={closeModal}>
          {t("INITIATE_PROMOTION.FORM.MODAL.BUTTON.CANCEL")}
        </Button>
        <Button
          size="sm"
          fill="fill"
          type="primary"
          onClick={() => {
            onSaveAction(selectedID, employees);
          }}
        >
          {t("INITIATE_PROMOTION.FORM.MODAL.BUTTON.SAVE")}
        </Button>
      </div>
    </Modal>
  );
};

export default AddCommitteeMemberModal;
